//For Notifaction
export const ADD_NOTIC = "ADD_NOTIC"
export const ADD_NOTIC_RED = "ADD_NOTIC_RED"

export const GET_NOTIC = "GET_NOTIC"
export const GET_NOTIC_RED = "GET_NOTIC_RED"

export const UPDATE_NOTIC = "UPDATE_NOTIC"
export const UPDATE_NOTIC_RED = "UPDATE_NOTIC_RED"

export const DELETE_NOTIC = "DELETE_NOTIC"
export const DELETE_NOTIC_RED = "DELETE_NOTIC_RED"

//For Category
export const ADD_CATEGORY = "ADD_CATEGORY"
export const ADD_CATEGORY_RED = "ADD_CATEGORY_RED"

export const GET_CATEGORY = "GET_CATEGORY"
export const GET_CATEGORY_RED = "GET_CATEGORY_RED"

export const UPDATE_CATEGORY = "UPDATE_CATEGORY"
export const UPDATE_CATEGORY_RED = "UPDATE_CATEGORY_RED"

export const DELETE_CATEGORY = "DELETE_CATEGORY"
export const DELETE_CATEGORY_RED = "DELETE_CATEGORY_RED"

//For CONTACT
export const ADD_CONTACT = "ADD_CONTACT"
export const ADD_CONTACT_RED = "ADD_CONTACT_RED"

export const GET_CONTACT = "GET_CONTACT"
export const GET_CONTACT_RED = "GET_CONTACT_RED"

export const UPDATE_CONTACT = "UPDATE_CONTACT"
export const UPDATE_CONTACT_RED = "UPDATE_CONTACT_RED"

export const DELETE_CONTACT = "DELETE_CONTACT"
export const DELETE_CONTACT_RED = "DELETE_CONTACT_RED"

//For User
export const ADD_USER = "ADD_USER"
export const ADD_USER_RED = "ADD_USER_RED"

export const GET_USER = "GET_USER"
export const GET_USER_RED = "GET_USER_RED"

export const UPDATE_USER = "UPDATE_USER"
export const UPDATE_USER_RED = "UPDATE_USER_RED"

export const DELETE_USER = "DELETE_USER"
export const DELETE_USER_RED = "DELETE_USER_RED"

//For NewLetter
export const ADD_NEWSLETTER = "ADD_NEWSLETTER"
export const ADD_NEWSLETTER_RED = "ADD_NEWSLETTER_RED"

export const GET_NEWSLETTER = "GET_NEWSLETTER"
export const GET_NEWSLETTER_RED = "GET_NEWSLETTER_RED"

export const DELETE_NEWSLETTER = "DELETE_NEWSLETTER"
export const DELETE_NEWSLETTER_RED = "DELETE_NEWSLETTER_RED"